import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';

export const CustomLinks = styled(Box)(({ theme }) => ({
	'&:first-of-type': {
		paddingTop: theme.spacing(1),
	},
	' .MuiDivider-root:first-of-type': {
		display: 'none',
	},
}));
